import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import DialogModal from '../../common/DialogModal';
import Input from 'material-ui/Input';
import MuiButton from 'material-ui/Button';
import Button from '../../Parts/Button'
import Trash from '../../Icons/Trash';
import * as errMessages from '../../../constants/ErrorMessages'
import * as messages from '../../../constants/Messages'
import NotificationBar from '../../Parts/NotificationBar.jsx'
import { TagType } from '../../../constants/ComponentTypes';

const { Set } = require('immutable');

const styles = () => ({
  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '600px',
  },

  contentContainer: {
    padding: '25px',
    margin: 0,
  },

  deleteContentContainer: {
    padding: '50px 50px',
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '450px',
    boxSizing: 'border-box',
    background: '#FFFFFF',
    textAlign: 'left',
  },

  caution: {
    height: '15px',
    width: '15px',
    borderRadius: '50%',
    lineHeight: '15px',
    textAlign: 'center',
    background: '#71737A',
    color: '#FFFFFF',
    display: 'inline-block',
    marginRight: '5px',
    fontSize: '9px',
    verticalAlign: 'middle'
  },

  emptyContainer: {
    padding: '50px',
    position: 'relative',
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    boxSizing: 'border-box',
    width: '100%',
  },

  container: {
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  row: {
    padding: '15px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    borderBottom: '1px solid #D8DBDF',
    boxSizing: 'border-box',
  },

  input: {
    boxSizing: 'border-box',
    height: '38px',
    fontSize: '15px',
  },

  button: {
    border: '1px solid #D8DBDF',
    marginLeft: '10px',
    fontSize: '15px',
    height: '38px',
    boxSizing: 'border-box',
    minWidth: 'unset',
    padding: 0,
  },

  buttonContainer: {
    display: 'inline-flex',
    width: '100%',
    justifyContent: 'space-evenly',
    marginTop: '40px',
  }
});

class ManageTagsDialog extends React.Component {
  state = {
    tags: [],
    tag: '',
    errors: {},
    showDeleteDialog: false,
    showNotification: false,
    message: '',
    messageType: 'success',
  }

  componentWillMount() {
    this.setState({
      tags: this.props.tags
    })
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isLoadingSidebar && !nextProps.isLoadingSidebar) {
      this.setState({
        tags: nextProps.tags
      })
    }

    if (this.props.isDeletingAddressTags && !nextProps.isDeletingAddressTags) {
      this.displayNotification(messages.DELETE_SUCCESS, "green");
    }

    if (!this.props.isDeletingAddressTags && nextProps.isDeletingAddressTags) {
      this.displayNotification(messages.DELETING, "success");
    }

    if (this.props.isUpdatingAddressTags && !nextProps.isUpdatingAddressTags) {
      if (!nextProps.errorMessage) {
        this.displayNotification(messages.SAVE_SUCCESS, "green");
      }
    }
  }

  handleChange = (tag, index) => (e) => {
    let tags = [...this.state.tags];
    let errors = { ...this.state.errors };

    tags[index] = e.target.value;

    if (!e.target.value) {
      errors[index] = errMessages.ERR_EMPTY;
    } else {
      delete errors[index];
    }

    this.setState({
      tags: tags,
      errors: errors,
    })
  }

  handleFocus = tag => () => {
    this.textOnFocus = tag;
  }

  handleBlur = (tag, index) => () => {
    if (tag !== this.textOnFocus && !this.state.errors.hasOwnProperty(index)) {
      this.props.updateTagName({
        'tag_name': this.textOnFocus,
        'new_tag_name': tag,
        'type': this.props.type,
      })
    }
  }

  //Blur the input field when Enter key is pressed
  handleEnterKeyPressed = (e) => {
    const enterKeyCode = 13;
    if (e.keyCode === enterKeyCode) {
      e.target.blur();
    }
  }

  handleShow = tag => () => {
    let tagSet = Set([tag]);

    switch (this.props.type) {
      case TagType.CUSTOM_TAG:
        this.props.updateFilter({ tag: tagSet });
        break;
      case TagType.TARGET_LIST:
        this.props.updateFilter({ target_list_tag: tagSet });
        break;
      default:
    }

    this.props.toggleDialog();
  }

  handleDelete = () => {
    this.setState({
      showDeleteDialog: false,
    })

    this.props.deleteTag({ 'tag_name': this.state.tag, 'type': this.props.type });
    this.props.chipsDelete('tag', this.state.tag)
    this.props.toggleDialog();
  }

  formatDeleteText = (tag) => {
    const dialogText = this.displayDialogText();
    switch (this.props.type) {
      case TagType.CUSTOM_TAG:
        return `リスト「${tag}」から選択した${dialogText}を除外します。よろしいですか？`;
      case TagType.TARGET_LIST:
        return `「${tag}」を削除します。アドレスは削除されません。よろしいですか？`;
      default:
        return '';
    }
  }

  formatEmptyText = () => {
    switch (this.props.type) {
      case TagType.CUSTOM_TAG:
        return `リストはありません。`;
      case TagType.TARGET_LIST:
        return `ターゲットリストがありません。`;
      default:
        return '';
    }
  }

  toggleDeleteDialog = (tag) => () => {
    this.setState({
      tag: tag,
      showDeleteDialog: !this.state.showDeleteDialog
    });
  }

  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    })
  };

  displayDialogText = () => {
    let dialogText = 'アドレス';
    // キーマンデータベースの場合は文言の表示を「キーマン」に変更する
    if (document.URL.match("/executive-list")) {
      dialogText = 'キーマン';
    }
    return dialogText;
  };

  renderNotification = () => {
    return (
      <div style={{ position: 'fixed', zIndex: 10000, top: 10, left: 'calc(50% - 100px)' }}>
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={() => {
            this.setState({ showNotification: false })
          }}
          autoClose={true}
          animation="fade"
        >
        </NotificationBar>
      </div>
    )
  }

  renderRow = (tag, index, isLast = false) => {
    const { classes, isDeletingAddressTags, isUpdatingAddressTags } = this.props;

    let disabled = isUpdatingAddressTags || (isDeletingAddressTags && tag === this.state.tag);

    return (
      <div className={classes.row} key={index} style={{ borderBottom: isLast ? 'none' : '1px solid #D8DBDF' }}>
        <Input
          key={index}
          value={tag}
          disableUnderline={true}
          classes={{
            input: classes.input
          }}
          style={{ flex: 1 }}
          placeholder="名前を入力"
          onChange={this.handleChange(tag, index)}
          onFocus={this.handleFocus(tag)}
          onBlur={this.handleBlur(tag, index)}
          onKeyDown={this.handleEnterKeyPressed}
          error={this.state.errors.hasOwnProperty(tag)}
          disabled={disabled}
        />

        <MuiButton className={classes.button} style={{ width: '70px' }} disabled={disabled} onClick={this.handleShow(tag)}>
          表示
        </MuiButton>

        <MuiButton className={classes.button} style={{ width: '38px' }} disabled={disabled} onClick={this.toggleDeleteDialog(tag)}>
          <Trash height={16} width={16} color={disabled ? "rgba(0, 0, 0, 0.26)" : "#181819"} />
        </MuiButton>
      </div>
    )
  }

  renderDeleteDialog = () => {
    const { classes } = this.props;

    return (
      <DialogModal
        open={this.state.showDeleteDialog}
        onClose={this.props.toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          contentContainer: classes.deleteContentContainer
        }}
      >
        <Typography variant="subheading" className={classes.text} style={{ fontWeight: 'bold' }}>
          {this.formatDeleteText(this.state.tag)}
        </Typography>
        {(this.props.type === TagType.CUSTOM_TAG) && (
          <Typography variant="body2" className={classes.text} style={{ marginTop: '25px', fontSize: '15px' }}>
            <span className={classes.caution}>！</span>空になったリストは自動的に削除されます。
          </Typography>
        )}

        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={this.toggleDeleteDialog('')}
            text="キャンセル"
            type="ghost">
          </Button>
          <Button
            handleClickButton={this.handleDelete}
            text="削除"
          >
          </Button>
        </div>
      </DialogModal>
    );
  };

  render() {
    const { classes, toggleDialog, isOpen, title } = this.props;
    const { tags } = this.state;

    let notification = this.renderNotification();

    if (this.state.showDeleteDialog) {
      return this.renderDeleteDialog();
    } else {
      return (
        <DialogModal
          title={title}
          open={isOpen}
          onClose={toggleDialog}
          aria-labelledby="pop-up-window"
          maxWidth={false}
          classes={{
            paper: classes.paper,
            contentContainer: classes.contentContainer
          }}
        >
          {(() => {
            if (this.props.tags.length === 0 || this.state.tags.length === 0) {
              return (
                <div className={classes.emptyContainer}>
                  <Typography variant="body2" style={{ color: '#71737B' }}>
                    {this.formatEmptyText()}
                  </Typography>
                </div>
              )
            } else {
              return (
                <div className={classes.container}>
                  {Object.values(tags).map((tag, i) => this.renderRow(tag, i, i === tags.length - 1))}
                </div>
              )
            }
          })()}
          {notification}
        </DialogModal>
      );
    }
  }
}

ManageTagsDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  tags: PropTypes.array.isRequired,
  deleteTag: PropTypes.func.isRequired,
  updateTagName: PropTypes.func.isRequired,
  updateFilter: PropTypes.func.isRequired,
  isDeletingAddressTags: PropTypes.bool,
  isLoadingSidebar: PropTypes.bool,
  errorMessage: PropTypes.string,
  chipsDelete: PropTypes.func.isRequired,
  isUpdatingAddressTags: PropTypes.bool,
};

export default withStyles(styles)(ManageTagsDialog);



// WEBPACK FOOTER //
// ./src/components/AddressBook/dialogs/ManageTagsDialog.jsx